namespace advisorop.components.servicer {

    export class SecuritiesListNewController {
        allocationPlans: domains.IAFSecurityAllocationPlan[] = [];
        assetClassnClassns: domains.IAFAssetClassnClassn[] = [];
        assetClassnColIds: string[] = [];
        allocationPlan: domains.IAFSecurityAllocationPlan = {
            //allocationPlanType: domains.AllocationPlanType.BO_SYSTEM_ALLOCATION_PLAN,
            afAssetClassnModelId: null,
            allocations: []
        };
        advisoryFirms: Array<domains.IAdvisoryFirm> = [];
        selAdvisoryFirm: domains.IAdvisoryFirm;
        selAllocationPlan: domains.IAFSecurityAllocationPlan;
        dg: DevExpress.ui.dxDataGridOptions;
        popupOptions: DevExpress.ui.dxPopupOptions;
        allowEditing = false;
        showStyleBased = false;
        saveInProgress = false;
        public afcModels: domains.IAFAssetClassnModel[] = [];
        planName = "";
        public selAFAssetClassModel: domains.IAFAssetClassnModel = null;
        visiblePopup = false;
        dgComponent: DevExpress.ui.dxDataGrid;

        dgRowsForSaving = [];
        dgNumOfRowsInValidation: number = 0;
        loadingAllocationPlans = true;
        activatingPlan = false;

        allocationRule: any = { type: "range", min: 0, max: 1, message: "Please enter value between 0 (0.00%) and 1 (100.00%)" };

        isInitializing: boolean = false;
        loadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#securitiesListNewContent" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Loading securities data...",
            bindingOptions: {
                visible: "vm.isInitializing"
            }
        }

        static $inject = ["servicerService", "generalService", "advisoryFirmApi"]
        constructor(private servicerService: services.ServicerService,
            private generalService: services.GeneralService,
            private advisoryFirmApi: services.AdvisoryFirmApi,
            private gs: services.GeneralService) {

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "Allocations"
                },
                bindingOptions: {
                    deep: true,
                    dataSource: "vm.allocationPlan.allocations",
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                paging: { enabled: true, pageSize: 30 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: true,
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: true },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                editing: {
                    mode: "batch",
                    allowUpdating: true
                },
                columns: [
                    { dataField: "securityTicker", caption: "Ticker", allowEditing: false, width: 50 },
                    { dataField: "securityUniqueSecId", caption: "Unique Sec ID", allowEditing: false, width: 80 },
                    { dataField: "securityName", caption: "Name", allowEditing: false, width: 120 },
                    { dataField: "securitySecurityType", caption: "Sec Type", allowEditing: false, width: 120 },
                    { dataField: "securitySecurityCategory", caption: "Sec Category", allowEditing: false, width: 120 },
                ],
                // highlight the contents of the cell when the user clicks on it
                // this makes it easier to change the allocation (no backspace necessary)
                onEditorPreparing: (e) => {
                    if (this.assetClassnColIds.findIndex(i => i == e.dataField) > -1
                        && e.parentType == "dataRow") {
                        e.editorOptions.onFocusIn = function (args) {
                            args.element.find("input").select();
                        }
                    }
                },
                onInitialized: (e) => {
                    this.dgComponent = e.component;
                },
                onRowUpdated: (e) => {
                    //const x: boolean = e.component.hasEditData();
                    //console.log(`onRowUpdated... Has edit data: ${x}`, e);
                },
                onRowInserted: (e) => {
                    //console.log(`onRowInserted...`, e);
                },
                onRowUpdating: (e) => {
                    // console.log(`onRowUpdating...`, e);

                    // at this point all changed rows are valid and ready to be saved
                    // but this method will fire for each changed row and we need to ensure that we call it only once
                    this.saveBatch(e.component);
                },
                onRowInserting: (e) => {
                    //console.log(`onRowInserting...`, e);
                },
                onRowValidating: (e) => {
                    //console.log(`onRowValidating...`, e);

                    if (!this.selAllocationPlan || !this.selAdvisoryFirm) {
                        e.isValid = false;
                        e.errorText = "Please select Advisory Firm and Allocation Plan";
                        toastr.error(e.errorText);
                        return;
                    }

                    // Add style based equity limits
                    //let minEquity = (e.newData.minEquity || e.newData.minEquity === 0) ? e.newData.minEquity : ((e.oldData.minEquity || e.oldData.minEquity === 0) ? e.oldData.minEquity : 0);
                    //let maxEquity = (e.newData.maxEquity || e.newData.maxEquity === 0) ? e.newData.maxEquity : ((e.oldData.maxEquity || e.oldData.maxEquity === 0) ? e.oldData.maxEquity : 0);
                    var assetClassAllocations: domains.AFAssetClassClassnsAlloc[] = []
                    var totalAllocation = 0;
                    this.assetClassnColIds.forEach(c => {
                        const alloc = (e.newData[c] || e.newData[c] === 0) ? e.newData[c] : ((e.oldData[c] || e.newData[c] === 0) ? e.oldData[c] : 0)
                        totalAllocation += alloc * 100;
                        const aca: domains.AFAssetClassClassnsAlloc = {
                            afAssetClassnClassnId: parseInt(c.substring(2)),
                            allocationPercentage: alloc
                        }
                        assetClassAllocations.push(aca);
                    });
                    e.isValid = totalAllocation === 100;
                    if (!e.isValid) {
                        e.errorText = "Total allocation needs to be 100%. Current allocation is " + totalAllocation + "%";
                        toastr.error(e.errorText);
                        return;
                    }

                    // remember validated data which needs to be saved later in a batch
                    const alloc: domains.IAFSecurityAssetClass = {
                        ...e.key,
                        securityAllocationPlanId: this.selAllocationPlan.id,
                        assetClassAllocations: assetClassAllocations
                        //minEquity: minEquity,
                        //maxEquity: maxEquity,
                    };
                    this.dgRowsForSaving.push(alloc);
                }
            };

            this.popupOptions = {
                deferRendering: false,
                width: 400,
                height: 300,
                contentTemplate: "info",
                showTitle: true,
                title: "Add New Asset Allocation Plan",
                dragEnabled: false,
                closeOnOutsideClick: false,
                showCloseButton: true,
                bindingOptions: {
                    visible: "vm.visiblePopup",
                },
                toolbarItems: [
                    {
                        widget: "dxButton",
                        location: "center",
                        toolbar: "bottom",
                        options: {
                            text: "Create",
                            type: "default",
                            onClick: () => {
                                this.createAllocationPlan();
                            }
                        }
                    },
                    {
                        widget: "dxButton",
                        location: "after",
                        toolbar: "bottom",
                        options: {
                            text: "Cancel",
                            type: "danger",
                            onClick: () => {
                                this.cancelNewModel();
                            }
                        }
                    }
                ]
            }
        }

        cancelNewModel() {
            this.planName = "";
            this.selAFAssetClassModel = null;
            this.visiblePopup = false;
        }

        saveBatch = (dg: DevExpress.ui.dxDataGrid) => {
            if (!this.saveInProgress) {
                this.saveInProgress = true;

                if (this.dgRowsForSaving.length <= 0) {
                    return;
                }

                dg.beginCustomLoading(`Saving data, please wait...`);

                this.servicerService.updateAFSecurityAssetClassAllocations(this.dgRowsForSaving)
                    .then(response => {
                        toastr.success("Data has been successfully saved");
                        dg.endCustomLoading();
                    }, err => {
                        dg.endCustomLoading();
                        this.generalService.showErrorWithMessage(`Unexpected error occurred. 
We need to reload the data grid and your changes will be lost. 
Sorry for this inconvenience.`, err);
                        this.loadAllocationPlan();
                    }).finally(() => {
                        this.saveInProgress = false;
                    });
                this.dgRowsForSaving = [];
            }
        }

        //cloneAllocationPlan(): void {
        //    if (this.selAllocationPlan) {
        //        let planName = prompt("New allocation plan name");
        //        if (planName && planName.length > 0) {
        //            let originalAllocationPlan: domains.IAFSecurityAllocationPlan = {
        //                advisoryFirmId: this.selAllocationPlan.advisoryFirmId,
        //                //allocationPlanType: this.selAllocationPlan.allocationPlanType,
        //                aFAssetClassnModelId: this.selAllocationPlan.aFAssetClassnModelId,
        //                id: this.selAllocationPlan.id,
        //                name: this.selAllocationPlan.name,
        //            };
        //            this.servicerService.cloneAFSecurityAllocationPlan(this.selAdvisoryFirm.id, planName, originalAllocationPlan)
        //                .then(response => {
        //                    this.allocationPlans.push(response.data);
        //                    this.allocationPlan = response.data;
        //                    //this.allowEditing = this.allocationPlan.allocationPlanType > 0;
        //                    this.allowEditing = true;
        //                    //this.showStyleBased = this.allocationPlan.styleBased;
        //                    this.showStyleBased = false;
        //                    this.selAllocationPlan = response.data;
        //                    toastr.success("New allocation plan has been created");
        //                },
        //                err => toastr.error("Error when cloning allocation plan. ERROR " + err.status + " " + err.data));
        //        }
        //    }
        //};

        showCreateAllocationPlan(): void {
            this.visiblePopup = true;
        }

        createAllocationPlan(): void {
            if (this.planName == null || this.planName.length == 0) {
                toastr.warning("Please enter a plan name.");
                return;
            }

            if (this.selAFAssetClassModel == null) {
                toastr.warning("Please select an allocation model to use under this alocation plan.");
                return;
            }

            const allocationPlan: domains.IAFSecurityAllocationPlan = {
                id: 0,
                advisoryFirmId: this.selAdvisoryFirm.id,
                name: this.planName,
                afAssetClassnModelId: this.selAFAssetClassModel.id
            }

            this.servicerService.createAFSecurityAllocationPlan(allocationPlan)
                .then(response => {
                    this.allocationPlan = response.data;
                    const ind = this.afcModels.findIndex(w => w.id == allocationPlan.afAssetClassnModelId);
                    if (ind > -1) {
                        this.allocationPlan.name += " (Model: " + this.afcModels[ind].name + ")";
                    }
                    this.allocationPlans.push(response.data);
                    this.allowEditing = true;
                    this.showStyleBased = false;
                    this.selAllocationPlan = this.allocationPlan;
                    this.visiblePopup = false;
                    this.loadAllocationPlan();
                    toastr.success("New allocation plan has been created");
                },
                    err => toastr.error("Error when creating allocation plan. ERROR " + err.status + " " + err.data));
        }

        loadAllocationPlansAndAfcModels(): void {
            this.loadAllocationPlans(true);
        }

        selectActiveAllocationPlan(): void {
            const activePlanIndex = this.allocationPlans.findIndex(w => w.isActive == true);
            if (activePlanIndex > -1) {
                this.selAllocationPlan = this.allocationPlans[activePlanIndex];
                this.loadAllocationPlan();
            }
        }

        updatePlanNameDetails(): void {
            // display some additional details inline with the plan name
            this.allocationPlans.forEach(p => {
                if (p.isActive == true)
                    p.name = "Active Plan: " + p.name;
                const ind = this.afcModels.findIndex(w => w.id == p.afAssetClassnModelId);
                if (ind > -1) {
                    p.name += " (Model: " + this.afcModels[ind].name + ")";
                }
            });
        }

        loadAllocationPlans(loadModels: boolean = false): void {
            this.loadingAllocationPlans = true;
            this.allocationPlan = null;
            this.selAllocationPlan = null;
            if (this.selAdvisoryFirm) {
                this.servicerService.getAFSecurityAllocationPlans(this.selAdvisoryFirm.id)
                    .then(response => {
                        this.allocationPlans = response.data;
                        if (loadModels) {
                            this.servicerService.getAfcModels(this.selAdvisoryFirm.id, true)
                                .then(response => {
                                    this.afcModels = response.data;
                                    this.updatePlanNameDetails();
                                    this.loadingAllocationPlans = false;
                                    this.selectActiveAllocationPlan();
                                }), err => toastr.error("Error when trying to load asset class models. ERROR " + err.status + " " + err.data);
                        } else {
                            this.updatePlanNameDetails();
                            this.loadingAllocationPlans = false;
                            this.selectActiveAllocationPlan();
                        }
                    }), err => toastr.error("Error when trying to load allocation plans. ERROR " + err.status + " " + err.data)
            } else {
                this.allocationPlans = [];
            }
        };
        
        activateAllocationPlan() {
            if (this.selAllocationPlan) {
                this.activatingPlan = true;
                if (window.confirm("You are about to activate a new allocation plan. Are you sure?")) {
                    this.servicerService.activateAFSecurityAllocationPlan(this.selAllocationPlan.id)
                        .then(response => {
                            this.loadAllocationPlans();
                            toastr.success("This plan is now the active plan");
                        }, err => {toastr.error("Error trying to activate this plan. ERROR " + err.status + " " + err.data)}).finally(() => {
                            this.activatingPlan = false;
                        });
                }
            } else {
                this.afcModels = [];
            }
        }

        loadAllocationPlan(): void {
            if (this.selAllocationPlan) {
                this.isInitializing = true;

                // Delete asset class columns from prior allocation plan model
                this.assetClassnColIds.forEach(i => this.dgComponent.deleteColumn(i));
                this.assetClassnColIds = [];
                this.servicerService.getAFSecurityAllocationPlanAndClassns(this.selAllocationPlan.id)
                    .then(response => {
                        this.allocationPlan = response.data.item1;
                        this.assetClassnClassns = response.data.item2;
                        //this.allowEditing = this.allocationPlan.allocationPlanType > 0;
                        this.allowEditing = true;
                        //this.showStyleBased = this.allocationPlan.styleBased;
                        this.showStyleBased = false;

                        // Denormalize the allocations so that they can be displayed in the grid horizontally
                        this.assetClassnClassns.forEach(c => {
                            const col = "AC" + c.id.toString();
                            this.assetClassnColIds.push(col)
                            this.allocationPlan.allocations.forEach(a => {
                                const ind = a.assetClassAllocations.findIndex(aca => aca.afAssetClassnClassnId == c.id);
                                a[col] = ind > -1 ? a.assetClassAllocations[ind].allocationPercentage : 0;
                            });
                            this.dgComponent.addColumn (
                                {
                                    dataField: col, caption: c.name,
                                    format: { precision: 2, type: "percent" },
                                    allowEditing: true, validationRules: [this.allocationRule],
                                    width: 120
                                }
                            );
                        });

                        this.isInitializing = false;
                    },
                    err => {
                        toastr.error("Unexpected error when trying to load securities. ERROR " + err.status + " " + err.data);
                        this.isInitializing = false;
                    });
            }
            else {
                this.allocationPlan = {
                    allocations: []
                };
            }
        };

        //useStyleBased(): void {
        //    this.allocationPlan.styleBased = this.showStyleBased;
        //    this.servicerService.updateAFSecurityAllocationPlan(this.allocationPlan.id, this.allocationPlan.styleBased)
        //        .then(response => {
        //            console.log("Updated style based")
        //        }, err => toastr.error("Unexpected error when trying tu change style based. ERROR " + err.status + " " + err.data));
        //}
        loadAdvisoryFirms(): void {
            this.advisoryFirmApi.getAdvisoryFirms()
                .then(response => this.advisoryFirms = response.data,
                      err => toastr.error("Error occured when loading advisory firms. ERROR " + err.status + " " + err.data));
        }
        
        $onInit(): void {
            this.loadAdvisoryFirms();
        }

        $onChanges(evt): void {
            for (var key in evt) {                
            }
        }
        
    }
    
    class SecuritiesListNew implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
            };
            this.controller = SecuritiesListNewController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/securities-list-new.html";
        }
    }
    angular.module(Constants.APP).component("securitiesListNew", new SecuritiesListNew());

}